import React from "react";
import PropTypes from "prop-types";
import { Translate } from "react-localize-redux";
import { E_Modification } from "../../../store/Constants_StoreShared";
import { E_TimePeriod, buildPeriodToken, parsePeriodValue, toCalendarDateString } from "../../../models/Models_PeriodFilter";
import Dropdown from "./Dropdown";
import DatepickerInput from "./Datepicker/DatepickerInput";

/**
 * Time period filter input.
 * ---
 * Renders a period-type selector (today, yesterday, this/previous week,
 * this/last month, custom) and, when "custom" is selected, two additional date
 * inputs (from / to). Emits a single opaque token value (see Models_PeriodFilter)
 * so the selection round-trips through the listing query string like any other
 * filter, while {@link buildPeriodQueryFilters} expands it into the actual
 * backend conditions at query time.
 */
class PeriodFilter extends React.Component {
	constructor(props) {
		super(props);

		let {period, from, to} = parsePeriodValue(props.defaultValue);
		this.state = {period, from, to};
	}

	componentDidUpdate(prevProps) {
		//Keep in sync when the applied value changes externally (e.g. query string / clear all)
		if (prevProps.defaultValue !== this.props.defaultValue) {
			this.setState(parsePeriodValue(this.props.defaultValue));
		}
	}

	_emit(change) {
		const {onModify, path} = this.props;

		this.setState(change, () => {
			const {period, from, to} = this.state;
			onModify(E_Modification.ITEM_SET, path, buildPeriodToken(period, from, to));
		});
	}

	_handlePeriodChange(period) {
		//Reset the custom range whenever we leave the custom period
		if (period === E_TimePeriod.CUSTOM) {
			this._emit({period});
		} else {
			this._emit({period: period || null, from: null, to: null});
		}
	}

	render() {
		const {period, from, to} = this.state;

		return (
			<div className={"period-filter"}>
				<Dropdown
					options={Object.values(E_TimePeriod)}
					defaultValue={period || ''}
					canInvalidate={true}
					onLabel={item => window.translator.translate(`sessionPeriod_${item}`)}
					onModify={(type, path, value) => this._handlePeriodChange(value || null)}
				/>
				{
					period === E_TimePeriod.CUSTOM &&
					<div className={"period-filter-custom"}>
						<label>
							<span><Translate id={"from"}/></span>
							<DatepickerInput
								path={"from"}
								defaultValue={from ? `${from}T00:00:00` : null}
								canInvalidate={true}
								onModify={(type, path, value) => this._emit({from: toCalendarDateString(value)})}
							/>
						</label>
						<label>
							<span><Translate id={"to"}/></span>
							<DatepickerInput
								path={"to"}
								defaultValue={to ? `${to}T00:00:00` : null}
								canInvalidate={true}
								onModify={(type, path, value) => this._emit({to: toCalendarDateString(value)})}
							/>
						</label>
					</div>
				}
			</div>
		);
	}
}

PeriodFilter.propTypes = {
	defaultValue: PropTypes.string,
	path: PropTypes.string,
	onModify: PropTypes.func,
};

PeriodFilter.defaultProps = {
	onModify: () => null,
};

export default PeriodFilter;
